export const technicians = state => state.technicians
